import {Box, CircularProgress} from '@material-ui/core';
import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import {Dispatch} from 'redux';
import {Devices} from '../../../api/api';
import {getDeviceContent} from '../../../state/ducks/devices/operations';
import {getSettings} from '../../../state/ducks/notification-settings/operations';
import {localized} from '../../../state/i18n/i18n';
import {AppState} from '../../../state/store';
import JmTitle from '../../components/jm-title/jm-title';
import NotificationSettingsContainer from '../../components/set-notification-settings/settings-container/notification-settings-container';
import './notification-settings-page.scss';
import { NitrateNitrogenPrefix } from '../../../utilities/helpers/device-helper';

const mapStateToProps = (state: AppState) => {
  return {
    notificationsSettings: state.notificationSettingsReducer.notificationSettingsHashmap,
    pendingStatus: state.notificationSettingsReducer.pending,
    devices: state.devicesReducer.devices,
    retrivalStatus: state.notificationSettingsReducer.deviceRetrivalFailed,
    emptyListStatus: state.devicesReducer.receivedEmptyList,
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  getAllSettings: async () => (await getSettings())(dispatch),
  getUserDevices: async (dateFrom: Date = new Date(), dateTo: Date = new Date()) =>
    (await getDeviceContent(dateFrom, dateTo))(dispatch),
});

type Props = ReturnType<typeof mapDispatchToProps> & ReturnType<typeof mapStateToProps>;

class NotificationSettingsPage extends PureComponent<Props> {
  constructor(props: Props) {
    super(props);

    this.props.getUserDevices();
    this.props.getAllSettings();
  }

  private dataIsPending = () => {
    if (this.props.pendingStatus === true) {
      return (
        <div className="spinnerSettings">
          <CircularProgress size="4rem" />
        </div>
      );
    }
  };

  private mapUserDevices = () => {
    if (this.props.devices.length > 0) {
      return this.props.devices.map((device: Devices, index: number) => {
        if (device.deviceId?.toLocaleLowerCase().includes(NitrateNitrogenPrefix)) {
          return null;
        } else {
          return (
            <NotificationSettingsContainer
              deviceDataType={device.dataTypeName}
              deviceId={device.deviceId}
              index={index}
              key={device.deviceId}
            />
          );
        }
      });
    } else if (this.props.retrivalStatus === false && this.props.emptyListStatus === false) {
      return <div className="emptyMessageSettings">{localized('LoadingDevices')}</div>;
    } else return <div className="emptyMessageSettings">{localized('NoDevices')}</div>;
  };

  public render() {
    return (
      <JmTitle title="Notification Settings" shouldPrefixBrandName={true}>
        <div className="width scroll">
          <div className="headerMainPageContainer">
            <div className="mainPageHeader">{localized('Notification')}</div>
            <div className="mainPageHeaderSubheader desktop">
              {localized('SetNotificationsOnYourDevices')}
              <br /> {localized('YouCanSetForBothTemperatureAndNitrate')}
            </div>
            <div className="mainPageHeaderSubheader mobile">{localized('SetNotificationsForYourDevices')}</div>
          </div>
          <Box flexDirection="row" alignItems="flex-start" className="boxPage">
            {this.dataIsPending()}
            {this.mapUserDevices()}
          </Box>
        </div>
      </JmTitle>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(NotificationSettingsPage);
